rwgps = window.rwgps || {};

rwgps.Bitmask = function() { }
rwgps.Bitmask.prototype = {
  //this is naive and assumes only one option in the group is set
  //which is how it should be...
  getSetGroupOption: function(group) {
    var set;
    _.each(this.stuff, function(obj, key) {
      if(obj.group == group && obj.val > 0) {
        set = key;
      }
    });
    return set;
  },
  setOptions: function(opts) {
    _.each(this.stuff, function(obj) {
      obj.val = opts & obj.mask;
    });
  },
  getOptions: function() {
    var val = 0;
    _.each(this.stuff, function(obj) {
      val = val | obj.val;
    });
    return val;
  },
  setOption: function(opt, val) {
    var entry = this.stuff[opt];
    if(entry) {
      if(entry.group) {
        _.each(this.stuff, function(obj) {
          //deselect all entries in the same group
          if(obj.group == entry.group) obj.val = 0;
        });
      }
      entry.val = val ? entry.mask : 0;
    }
  },
  getOption: function(opt) {
    //no sanity check, since i want an exception if this is misused
    return this.stuff[opt].val & this.stuff[opt].mask;
  }
}
rwgps.Bitmask.Planner = function(opts) {
  //if entries share the same group, they act as radio buttons - meaning
  //setting one will automatically deselect any others in the same group.
  this.stuff = {
    //google basemaps
    roadmap:          {mask: 1, val: 1, group: "basemaps"}, //default to gmaps, so val is 1
    terrain:          {mask: 2, val: 0, group: "basemaps"},
    satellite:        {mask: 4, val: 0, group: "basemaps"},
    hybrid:           {mask: 8, val: 0, group: "basemaps"},
    //custom basemaps
    rwgps:            {mask: 16, val: 0, group: "basemaps"},
    osm:              {mask: 32, val: 0, group: "basemaps"},
    osmCycle:         {mask: 64, val: 0, group: "basemaps"},
    esriTopo:         {mask: 128, val: 0, group: "basemaps"},
    usgsTopo:         {mask: 256, val: 0, group: "basemaps"},
    giTopo:           {mask: 512, val: 0, group: "basemaps"},
    osmOutdoor:       {mask: 1024, val: 0, group: "basemaps"},
    usgsTopoLegacy:   {mask: 2048, val: 0, group: "basemaps"},
    //4096 is baselayer placeholder
    //layers now
    gmapsBikeOverlay: {mask: 8192, val: 0},
    giSkiOverlay:     {mask: 16384, val: 0},
    overrideUnits:    {mask: 32768, val: 0},
    metricUnits:      {mask: 65536, val: 0}
  }
  if(opts) this.setOptions(opts);
}
rwgps.Bitmask.Planner.prototype = new rwgps.Bitmask();









rwgps.ClickOptions = function(opts) {
  this.CYCLING_MODE_MASK = 1;
  this.WALKING_MODE_MASK = 2;
  this.DRIVING_MODE_MASK = 4;
  this.AVOID_HIGHWAYS_MASK = 8;
  this.FOLLOW_ROADS_MASK = 16;
  this.AVOID_TUNNELS_MASK = 32;
  this.GMAPS_MASK = 64;
  this.OSM_MASK = 128
  this.ARCGIS_MASK = 256;
  this.GI_MASK = 512;
  this.AVOID_CARS_ONLY_MASK = 1024;
  this.AVOID_FERRIES_MASK = 2048;
  this.AVOID_ONEWAYS_MASK = 4096;
  this.AVOID_DIRT_ROADS_MASK = 8192;
  this.AVOID_TRAILS_MASK = 16384;
  this.AVOID_WATER_MASK = 32768;
  this.CYCLING_EXPERIMENT_MODE_MASK = 65536;

  this._cyclingMode = this.CYCLING_MODE_MASK; //default
  this._cyclingExperimentMode = 0;
  this._walkingMode = 0;
  this._drivingMode = 0;
  this._avoidHighways = 0;
  this._avoidTunnels = 0;
  this._avoidCarsOnly = 0;
  this._avoidFerries = 0;
  this._avoidOneWays = 0;
  this._avoidTrails = 0;
  this._avoidDirtRoads = 0;
  this._avoidWater = 0;
  this._followRoads = this.FOLLOW_ROADS_MASK; //default
  this._gmaps = this.GMAPS_MASK;
  this._osm = 0;
  this._arcgis = 0;
  this._gi = 0;

  if(opts !== undefined) this.setOptions(opts);
}

rwgps.ClickOptions.prototype = {
  setOptions: function(opts) {
    this._cyclingMode        = opts & this.CYCLING_MODE_MASK;
    this._cyclingExperimentMode        = opts & this.CYCLING_EXPERIMENT_MODE_MASK;
    this._walkingMode        = opts & this.WALKING_MODE_MASK;
    this._drivingMode        = opts & this.DRIVING_MODE_MASK;
    this._avoidOneWays       = opts & this.AVOID_ONEWAYS_MASK;
    this._avoidHighways      = opts & this.AVOID_HIGHWAYS_MASK;
    this._avoidTunnels       = opts & this.AVOID_TUNNELS_MASK;
    this._avoidFerries       = opts & this.AVOID_FERRIES_MASK;
    this._avoidDirtRoads     = opts & this.AVOID_DIRT_ROADS_MASK;
    this._avoidTrails        = opts & this.AVOID_TRAILS_MASK;
    this._avoidCarsOnly      = opts & this.AVOID_CARS_ONLY_MASK;
    this._avoidWater         = opts & this.AVOID_WATER_MASK;
    this._followRoads        = opts & this.FOLLOW_ROADS_MASK;
    this._gmaps              = opts & this.GMAPS_MASK;
    this._osm                = opts & this.OSM_MASK;
    this._arcgis             = opts & this.ARCGIS_MASK;
    this._gi                 = opts & this.GI_MASK;

    //ensure we always have some mode for direction requests,
    //just in case we have a bum options field
    if((this._cyclingMode | this._cyclingExperimentMode | this._walkingMode | this._drivingMode) == 0) this._drivingMode = 1;
    if((this._gi | this._arcgis | this._osm | this._gmaps) == 0) this._gmaps = this.GMAPS_MASK;
  },
  setPartialOptions: function(opts) {
    if(opts & this.CYCLING_MODE_MASK)
      this._cyclingMode        = opts & this.CYCLING_MODE_MASK
    if(opts & this.CYCLING_EXPERIMENT_MODE_MASK)
      this._cyclingExperimentMode        = opts & this.CYCLING_EXPERIMENT_MODE_MASK
    if(opts & this.WALKING_MODE_MASK)
      this._walkingMode        = opts & this.WALKING_MODE_MASK
    if(opts & this.DRIVING_MODE_MASK)
      this._drivingMode        = opts & this.DRIVING_MODE_MASK
    if(opts & this.AVOID_ONEWAYS_MASK)
      this._avoidOneWays       = opts & this.AVOID_ONEWAYS_MASK
    if(opts & this.AVOID_HIGHWAYS_MASK)
      this._avoidHighways      = opts & this.AVOID_HIGHWAYS_MASK
    if(opts & this.AVOID_TUNNELS_MASK)
      this._avoidTunnels       = opts & this.AVOID_TUNNELS_MASK
    if(opts & this.AVOID_FERRIES_MASK)
      this._avoidFerries       = opts & this.AVOID_FERRIES_MASK
    if(opts & this.AVOID_DIRT_ROADS_MASK)
      this._avoidDirtRoads     = opts & this.AVOID_DIRT_ROADS_MASK
    if(opts & this.AVOID_TRAILS_MASK)
      this._avoidTrails        = opts & this.AVOID_TRAILS_MASK
    if(opts & this.AVOID_CARS_ONLY_MASK)
      this._avoidCarsOnly      = opts & this.AVOID_CARS_ONLY_MASK
    if(opts & this.AVOID_WATER_MASK)
      this._avoidWater         = opts & this.AVOID_WATER_MASK
    if(opts & this.FOLLOW_ROADS_MASK)
      this._followRoads        = opts & this.FOLLOW_ROADS_MASK
    if(opts & this.GMAPS_MASK)
      this._gmaps              = opts & this.GMAPS_MASK
    if(opts & this.OSM_MASK)
      this._osm                = opts & this.OSM_MASK
    if(opts & this.ARCGIS_MASK)
      this._arcgis             = opts & this.ARCGIS_MASK
    if(opts & this.GI_MASK)
      this._gi                 = opts & this.GI_MASK
  },
  getProviderOptions: function() {
    return (this._gmaps & this.GMAPS_MASK) |
      (this._osm & this.OSM_MASK) |
      (this._arcgis & this.ARCGIS_MASK) |
      (this._gi & this.GI_MASK);
  },
  getRestrictionOptions: function() {
      return (this._avoidOneWays & this.AVOID_ONEWAYS_MASK) |
      (this._avoidHighways & this.AVOID_HIGHWAYS_MASK) |
      (this._avoidTunnels & this.AVOID_TUNNELS_MASK) |
      (this._avoidFerries & this.AVOID_FERRIES_MASK) |
      (this._avoidDirtRoads & this.AVOID_DIRT_ROADS_MASK) |
      (this._avoidTrails & this.AVOID_TRAILS_MASK) |
      (this._avoidCarsOnly & this.AVOID_CARS_ONLY_MASK) |
      (this._avoidWater & this.AVOID_WATER_MASK)
  },
  getModeOptions: function() {
    return (this._cyclingMode & this.CYCLING_MODE_MASK) |
      (this._cyclingExperimentMode & this.CYCLING_EXPERIMENT_MODE_MASK) |
      (this._walkingMode & this.WALKING_MODE_MASK) |
      (this._drivingMode & this.DRIVING_MODE_MASK) |
      (this._followRoads & this.FOLLOW_ROADS_MASK)
  },
  getOptions: function() {
    return this.getModeOptions() |
      this.getRestrictionOptions() |
      this.getProviderOptions();
  },
  getOption: function(opt) {
    switch(opt) {
      case "avoidHighways": return this._avoidHighways & this.AVOID_HIGHWAYS_MASK; 
      case "avoidTunnels": return this._avoidTunnels & this.AVOID_TUNNELS_MASK; 
      case "avoidOneWays": return this._avoidOneWays & this.AVOID_ONEWAYS_MASK; 
      case "avoidFerries": return this._avoidFerries & this.AVOID_FERRIES_MASK; 
      case "avoidDirtRoads": return this._avoidDirtRoads & this.AVOID_DIRT_ROADS_MASK; 
      case "avoidTrails": return this._avoidTrails & this.AVOID_TRAILS_MASK; 
      case "avoidCarsOnly": return this._avoidCarsOnly & this.AVOID_CARS_ONLY_MASK; 
      case "avoidWater": return this._avoidWater & this.AVOID_WATER_MASK; 
    }
    return false;
  },
  setOption: function(opt, val) {
    switch(opt) {
      case "avoidHighways": this._avoidHighways = val ? this.AVOID_HIGHWAYS_MASK : 0; break;
      case "avoidTunnels": this._avoidTunnels = val ? this.AVOID_TUNNELS_MASK : 0; break;
      case "avoidOneWays": this._avoidOneWays = val ? this.AVOID_ONEWAYS_MASK : 0; break;
      case "avoidFerries": this._avoidFerries = val ? this.AVOID_FERRIES_MASK : 0; break;
      case "avoidDirtRoads": this._avoidDirtRoads = val ? this.AVOID_DIRT_ROADS : 0; break;
      case "avoidTrails": this._avoidTrails = val ? this.AVOID_TRAILS_MASK : 0; break;
      case "avoidCarsOnly": this._avoidCarsOnly = val ? this.AVOID_CARS_ONLY_MASK : 0; break;
      case "avoidWater": this._avoidWater = val ? this.AVOID_WATER_MASK : 0; break;
    }
  },
  getEnabledRestrictions: function() {
    var res = [];
    if(this._avoidHighways) res.push("avoidHighways");
    if(this._avoidTunnels) res.push("avoidTunnels");
    if(this._avoidOneWays) res.push("avoidTunnels");
    if(this._avoidFerries) res.push("avoidFerries");
    if(this._avoidDirtRoads) res.push("avoidDirtRoads");
    if(this._avoidTrails) res.push("avoidTrails");
    if(this._avoidCarsOnly) res.push("avoidCarsOnly");
    if(this._avoidWater) res.push("avoidWater");
    return res;
  },
  avoidWater: function(val) {
    if(val === undefined) return this._avoidWater > 0;
    this._avoidWater = val ? this.AVOID_WATER_MASK : 0;
  },
  avoidOneWays: function(val) {
    if(val === undefined) return this._avoidOneWays > 0;
    this._avoidOneWays = val ? this.AVOID_ONEWAYS_MASK : 0;
  },
  avoidHighways: function(val) {
    if(val === undefined) return this._avoidHighways > 0;
    this._avoidHighways = val ? this.AVOID_HIGHWAYS_MASK : 0;
  },
  avoidTunnels: function(val) {
    if(val === undefined) return this._avoidTunnels > 0;
    this._avoidTunnels = val ? this.AVOID_TUNNELS_MASK : 0;
  },
  avoidFerries: function(val) {
    if(val === undefined) return this._avoidFerries > 0;
    this._avoidFerries = val ? this.AVOID_FERRIES_MASK : 0;
  },
  avoidDirtRoads: function(val) {
    if(val === undefined) return this._avoidDirtRoads > 0;
    this._avoidDirtRoads = val ? this.AVOID_DIRT_ROADS_MASK : 0;
  },
  avoidTrails: function(val) {
    if(val === undefined) return this._avoidTrails > 0;
    this._avoidTrails = val ? this.AVOID_TRAILS_MASK : 0;
  },
  avoidCarsOnly: function(val) {
    if(val === undefined) return this._avoidCarsOnly > 0;
    this._avoidCarsOnly = val ? this.AVOID_CARS_ONLY_MASK : 0;
  },
  followRoads: function(val) {
    if(val === undefined) return this._followRoads > 0;
    this._followRoads = val ? this.FOLLOW_ROADS_MASK : 0;
  },
  walkingMode: function(val) {
    if(val === undefined) return this._walkingMode > 0;
    if(val) {
      this._walkingMode = this.WALKING_MODE_MASK;
      this._cyclingExperimentMode = 0;
      this._cyclingMode = 0;
      this._drivingMode = 0;
    }
  },
  cyclingMode: function(val) {
    if(val === undefined) return this._cyclingMode > 0;
    if(val) {
      this._walkingMode = 0;
      this._cyclingExperimentMode = 0;
      this._cyclingMode = this.CYCLING_MODE_MASK;
      this._drivingMode = 0;
    }
  },
  cyclingExperimentMode: function(val) {
    if(val === undefined) return this._cyclingExperimentMode > 0;
    if(val) {
      this._walkingMode = 0;
      this._cyclingExperimentMode = this.CYCLING_EXPERIMENT_MODE_MASK;
      this._cyclingMode = 0;
      this._drivingMode = 0;
    }
  },
  drivingMode: function(val) {
    if(val === undefined) return this._drivingMode > 0;
    if(val) {
      this._walkingMode = 0;
      this._cyclingMode = 0;
      this._cyclingExperimentMode = 0;
      this._drivingMode = this.DRIVING_MODE_MASK;
    }
  },
  googleRouting: function(val) {
    if(val === undefined) return this._gmaps > 0;
    this._gmaps = this.GMAPS_MASK;
    this._osm = 0;
    this._gi = 0;
    this._arcgis = 0;
  },
  osmRouting: function(val) {
    if(val === undefined) return this._osm > 0;
    this._gmaps = 0;
    this._osm = this.OSM_MASK;
    this._gi = 0;
    this._arcgis = 0;
  },
  arcgisRouting: function(val) {
    if(val === undefined) return this._arcgis > 0;
    this._gmaps = 0;
    this._osm = 0;
    this._gi = 0;
    this._arcgis = this.ARCGIS_MASK;
  },
  giRouting: function(val) {
    if(val === undefined) return this._gi > 0;
    this._gmaps = 0;
    this._osm = 0;
    this._gi = this.GI_MASK;
    this._arcgis = 0;
  }
};



// WEBPACK FOOTER //
// ./public/javascripts/js_maps/click_options.js